export { default as useUpdateEffect } from './useUpdateEffect';
export * from './useUpdateEffect';
//# sourceMappingURL=index.js.map